/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Steps in the post-clinical user progression
 */
export type ProgressionStep =
  (typeof ProgressionStep)[keyof typeof ProgressionStep];

export const ProgressionStep = {
  explainer: "explainer",
  authentication: "authentication",
  profile_completion: "profile_completion",
  subjective_shareback: "subjective_shareback",
  video_visit_explainer: "video_visit_explainer",
  state_validation: "state_validation",
  start_database_id_verification: "start_database_id_verification",
  confirm_id_verification_status: "confirm_id_verification_status",
  consent: "consent",
  payment_selection: "payment_selection",
  stripe_redirect: "stripe_redirect",
  visit_selection: "visit_selection",
  clinic_redirect: "clinic_redirect",
  pharmacy_selection: "pharmacy_selection",
  async_visit: "async_visit",
  partner_remediation: "partner_remediation",
  surescripts_consent: "surescripts_consent",
  renewals_chosen: "renewals_chosen",
  rfe: "rfe",
  ai_doctor_consent: "ai_doctor_consent",
  rx_history_fetch: "rx_history_fetch",
  active_medications: "active_medications",
  vitals: "vitals",
  cms_eligibility: "cms_eligibility",
  cms_consent: "cms_consent",
  questionnaire: "questionnaire",
  care_team_collection: "care_team_collection",
  access_ineligible: "access_ineligible",
  affiliate_welcome: "affiliate_welcome",
} as const;
